import StagePage from '../stage/StagePage';

export default function Round3Page() {
  return <StagePage stage={3} />;
}
